import { render, staticRenderFns } from "./AppLastActivityInsert.vue?vue&type=template&id=4bfe6334"
import script from "./AppLastActivityInsert.vue?vue&type=script&lang=js"
export * from "./AppLastActivityInsert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports